import { saveCommandingOptions } from './saveCommandingOptions';
import type { CommandingViewMode } from 'owa-outlook-service-option-store';
import { logUsage } from 'owa-analytics';
import { getGuid } from 'owa-guid';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

export function saveCommandingViewModeOption(
    viewMode: CommandingViewMode,
    writeReason:
        | 'defaultInitialization'
        | 'modeChange'
        | 'win32Migration'
        | 'unspecified' = 'unspecified'
): void {
    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    const operationId = getGuid();
    logUsage('CommandingViewModeSave', mailboxInfo, {
        viewMode,
        writeReason,
        operationId,
        stage: 'requested',
    });

    saveCommandingOptions({ viewMode })
        .then(
            () => 'completed',
            () => 'failed'
        )
        .then(stage => {
            logUsage('CommandingViewModeSave', mailboxInfo, {
                viewMode,
                writeReason,
                operationId,
                stage,
            });
        });
}
